import React from "react";
import {
  BASE_URL,
  XCHANGE_PLATFORM_NAME,
  APP_EVENT_ID,
  APP_EVENT_NAME,
  APP_EVENT_SUMMIT_URL,
  APP_BRAND_FOLDER,
} from "../utils/consts";
import styles from "./TopNav.module.css";

export const TOP_NAV_VARIANTS = {
  small: "sm", // mobile
  large: "lg", // desktop + tablet
};

const TopNav = ({ variant, username, userProfile }) => {
  if (!userProfile || !username) {
    return null;
  }

  return variant === TOP_NAV_VARIANTS.small ? (
    // Mobile variant
    <div className="collapse w-100" id="navbarToggleExternalContent">
      <div className="bg-dark p-4">
        <ul id="sidebarOpenNav-">
          <li>
            <a href={`${BASE_URL}/${XCHANGE_PLATFORM_NAME}/main/dashboard/`}>
              <i className="fas fa-home"></i>
              <span>Home</span>
            </a>
          </li>
          <li>
            <a href={`${BASE_URL}/${XCHANGE_PLATFORM_NAME}/main/people/`}>
              <i className="fas fa-user-friends"></i>
              <span>People</span>
            </a>
          </li>
          <li>
            <a href={`${BASE_URL}/${XCHANGE_PLATFORM_NAME}/main/projects/`}>
              <i className="fas fa-film"></i>
              <span>Projects</span>
            </a>
          </li>
          <li>
            <a
              href={`${BASE_URL}/${XCHANGE_PLATFORM_NAME}/${APP_EVENT_ID}/calendar/?pageIndex=1&searchText=&searchFilter=&sortby=&sortorder=&following=&followers=&profileId=&projectId=&interestB=&interestP1=&interestP2=#`}
              className="eventSidebarSubMenu"
            >
              <i className="ArrowSubEventItemID-12 pull-right expendarrowfold fas fa-angle-down"></i>
              <img
                className="eventCollapseSideMenu"
                src="/img/icons/conferenceicon.png"
                alt={APP_EVENT_NAME}
              />
              <span>{APP_EVENT_NAME}</span>
            </a>
            <ul className="SubEventItemID-12">
              <li>
                <a
                  href={`${BASE_URL}/${XCHANGE_PLATFORM_NAME}/${APP_EVENT_ID}/dashboard/`}
                >
                  <span>Event News</span>
                </a>
              </li>
              <li>
                <a href={`https://${APP_EVENT_SUMMIT_URL}/2021/agenda/`}>
                  <span>Agenda</span>
                </a>
              </li>
              <li>
                <a
                  href={`${BASE_URL}/${XCHANGE_PLATFORM_NAME}/${APP_EVENT_ID}/calendar/`}
                >
                  <span>Calendar</span>
                </a>
              </li>
              <li>
                <a
                  href={`${BASE_URL}/${XCHANGE_PLATFORM_NAME}/${APP_EVENT_ID}/messaginghub/`}
                >
                  <span>Messages</span>
                </a>
              </li>
              <li>
                <a
                  href={`${BASE_URL}/${XCHANGE_PLATFORM_NAME}/${APP_EVENT_ID}/projects/`}
                >
                  <span>Screening</span>
                </a>
              </li>
              <li>
                <a href={`https://${APP_EVENT_SUMMIT_URL}/2021/speakers/`}>
                  <span>Speakers</span>
                </a>
              </li>
              <li>
                <a
                  href={`${BASE_URL}/${XCHANGE_PLATFORM_NAME}/${APP_EVENT_ID}/people/`}
                >
                  <span>Delegates</span>
                </a>
              </li>
              <li>
                <a
                  href={`${BASE_URL}/${XCHANGE_PLATFORM_NAME}/${APP_EVENT_ID}/companyprofiles/directory`}
                >
                  <span>Exhibitors</span>
                </a>
              </li>
              <li>
                <a href={`https://${APP_EVENT_SUMMIT_URL}/2021/faq/#faq-q9`}>
                  <span>FAQ</span>
                </a>
              </li>
              <li>
                <a href="mailto:rslivecustomercare@brunico.com">
                  <span>Contact Us</span>
                </a>
              </li>
              <li className="active">
                <a href="/">
                  <span>Meeting Suite</span>
                </a>
              </li>
            </ul>
          </li>
        </ul>
        <ul className="navbar-nav px-3">
          <li className="nav-item text-nowrap">
            <a className="nav-link" href={`${BASE_URL}/account/logoff`}>
              Sign out
            </a>
          </li>
        </ul>
      </div>
    </div>
  ) : (
    // desktop variant
    <nav
      id={styles.topnav}
      className={`${styles.navbar} navbar navbar-light navbar-expand-md justify-content-between flex-md-nowrap p-0 w-100`}
    >
      <a href={BASE_URL} className="navbar-brand mr-0 p-0 pl-2 pl-md-4">
        <img
          src={`/brands/${APP_BRAND_FOLDER}/img/logo@2x.png`}
          width="166"
          className="brandLogo mw-100 d-none d-md-block"
          alt={`${APP_EVENT_NAME} logo`}
        />
        <img
          src={`/brands/${APP_BRAND_FOLDER}/img/logo-mobile@2x.png`}
          height="55"
          className="brandLogo d-md-none"
          alt={`${APP_EVENT_NAME} logo`}
        />
      </a>
      <div className="d-flex align-items-center col-6 col-md-auto">
        <div className="d-none d-md-block">
          <ul className="navbar-nav px-0">
            <li className="nav-item text-nowrap dropdown">
              <div className="dropdown">
                <button
                  className={`btn btn-secondary dropdown-toggle rounded-0 ${styles["navbar-user"]} `}
                  type="button"
                  id="dropdownMenuButton"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  <div
                    className={styles["navbar-profile"]}
                    style={{
                      backgroundImage: `url(${userProfile.ProfilePhotoFullPath})`,
                    }}
                  ></div>
                  {username && <span>{username}</span>}
                </button>
                <div
                  className="dropdown-menu dropdown-menu-right"
                  aria-labelledby="dropdownMenuButton"
                >
                  <a
                    className="dropdown-item"
                    href={`${BASE_URL}/${XCHANGE_PLATFORM_NAME}/main/profile/public/${userProfile.ProfileID}`}
                  >
                    View Profile
                  </a>
                  <a
                    className="dropdown-item"
                    href={`${BASE_URL}/${XCHANGE_PLATFORM_NAME}/main/profile/`}
                  >
                    Edit Profile
                  </a>
                  <a
                    className="dropdown-item"
                    href={`${BASE_URL}/${XCHANGE_PLATFORM_NAME}/${APP_EVENT_ID}/settings/`}
                  >
                    Account Settings
                  </a>
                  <div className="dropdown-divider"></div>
                  <a
                    className="dropdown-item"
                    href={`${BASE_URL}/account/logoff`}
                  >
                    Signout
                  </a>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div className="col-2 col-sm-auto d-md-none">&nbsp;</div>
      <button
        className="navbar-toggler position-absolute d-md-none collapsed"
        type="button"
        data-toggle="collapse"
        data-target="#navbarToggleExternalContent"
        aria-controls="sidebarMenu"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span className="navbar-toggler-icon"></span>
      </button>
    </nav>
  );
};

export default TopNav;
